module.exports = __webpack_public_path__ + "img/deskshelf06.a37b721a.jpg";